import { useTranslation } from 'react-i18next';
import { ChevronRight, Package, Store } from 'lucide-react';
import { formatCurrency, formatDate } from '~/utils';
import { OrderStatusBadge } from '~/components/ui/OrderStatusBadge';
import { Button } from '~/components/ui';

export function OrderCard({
  id,
  status,
  orderDate,
  sellingOrganizationName,
  itemCount,
  totalAmount,
  onClick,
}: {
  id: string;
  status: string;
  orderDate: string;
  sellingOrganizationName: string;
  itemCount: number;
  totalAmount: number;
  onClick?: () => void;
}) {
  const { t } = useTranslation('order');
  return (
    <div className="bg-white rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
      <div className="p-4 sm:p-6 border-b border-gray-100">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
          <div className="flex-1">
            <div className="flex items-center gap-3 mb-2">
              <h3 className="text-neut-prim font-semibold">{id}</h3>
              <OrderStatusBadge status={status} />
            </div>

            <div className="flex items-center gap-4 text-sm text-gray-600">
              <span>{formatDate(orderDate)}</span>
              <span>•</span>
              <div className="flex items-center gap-2">
                <Store size={14} />
                <span>{sellingOrganizationName}</span>
              </div>
            </div>
          </div>
          <div className="text-left sm:text-right">
            <p className="text-xs text-gray-500 mb-1">
              {t('order.total_amount')}
            </p>
            <p className="text-lg text-[#1A1A1A] font-semibold">
              {formatCurrency(totalAmount)}
            </p>
          </div>
        </div>
      </div>

      <div className="p-4 sm:p-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <Package size={16} />
            <span>{t('order.item_count', { count: itemCount })}</span>
          </div>
          <Button variant="ghost-primary" onClick={onClick} width="10rem">
            {t('order.view_details')}
            <ChevronRight size={16} />
          </Button>
        </div>
      </div>
    </div>
  );
}
